import React, { useEffect, useMemo, useState } from "react";
import api from "../services/api";

function Lessons({ setPage }) {
  const [industries, setIndustries] = useState([]);
  const [courses, setCourses] = useState([]);
  const [modules, setModules] = useState([]);
  const [lessons, setLessons] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const lessonsPerPage = 15;

  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterCourse, setFilterCourse] = useState("");
  const [filterModule, setFilterModule] = useState("");

  useEffect(() => {
    loadIndustries();
    loadCourses();
    loadModules();
    loadLessons();
  }, []);

  const loadIndustries = async () => {
    try {
      const res = await api.get("/industries");
      setIndustries(res.data.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const loadCourses = async () => {
    try {
      const res = await api.get("/courses");
      setCourses(res.data.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const loadModules = async () => {
    try {
      const res = await api.get("/modules");
      setModules(res.data.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const loadLessons = async () => {
    try {
      const res = await api.get("/lessons");
      setLessons(res.data.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDelete = async (id) => {
    const ok = window.confirm("Are you sure you want to delete this lesson?");
    if (!ok) return;

    try {
      await api.delete(`/lessons/${id}`);
      loadLessons();
    } catch (err) {
      console.log(err);
      alert("Failed to delete lesson");
    }
  };

  const filteredCourses = useMemo(() => {
    if (!filterIndustry) return courses;
    return courses.filter((c) => String(c.industry_id) === String(filterIndustry));
  }, [courses, filterIndustry]);

  const filteredModules = useMemo(() => {
    if (!filterCourse) return modules;
    return modules.filter((m) => String(m.course_id) === String(filterCourse));
  }, [modules, filterCourse]);

  const filteredLessons = useMemo(() => {
    return lessons.filter((lesson) => {
      const module = modules.find((m) => String(m.id) === String(lesson.module_id));
      const course = module
        ? courses.find((c) => String(c.id) === String(module.course_id))
        : null;

      if (filterIndustry && (!course || String(course.industry_id) !== String(filterIndustry))) {
        return false;
      }

      if (filterCourse && (!course || String(course.id) !== String(filterCourse))) {
        return false;
      }

      if (filterModule && String(lesson.module_id) !== String(filterModule)) {
        return false;
      }

      return true;
    });
  }, [lessons, modules, courses, filterIndustry, filterCourse, filterModule]);

  const indexOfLast = currentPage * lessonsPerPage;
const indexOfFirst = indexOfLast - lessonsPerPage;

const currentLessons = filteredLessons.slice(indexOfFirst, indexOfLast);
const nextPage = () => {
  if (currentPage < totalPages) {
    setCurrentPage(currentPage + 1);
  }
};

const prevPage = () => {
  if (currentPage > 1) {
    setCurrentPage(currentPage - 1);
  }
};

const totalPages = Math.ceil(filteredLessons.length / lessonsPerPage);
  
  return (
    <div style={{ padding: "30px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "25px",
          alignItems: "center"
        }}
      >
        <h2 style={{ margin: 0 }}>Lessons</h2>

        <button
          style={primaryBtn}
          onClick={() => setPage({ page: "add-lesson" })}
        >
          + Add New Lesson
        </button>
      </div>

      <div style={card}>
        <h3 style={{ marginBottom: "18px" }}>Filters</h3>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: "12px"
          }}
        >
          <select
            value={filterIndustry}
            onChange={(e) => {
              setFilterIndustry(e.target.value);
              setFilterCourse("");
              setFilterModule("");
            }}
            style={input}
          >
            <option value="">All Industries</option>
            {industries.map((industry) => (
              <option key={industry.id} value={industry.id}>
                {industry.name}
              </option>
            ))}
          </select>

          <select
            value={filterCourse}
            onChange={(e) => {
              setFilterCourse(e.target.value);
              setFilterModule("");
              setCurrentPage(1);
            }}
            style={input}
          >
            <option value="">All Courses</option>
            {filteredCourses.map((course) => (
              <option key={course.id} value={course.id}>
                {course.title}
              </option>
            ))}
          </select>

          <select
            value={filterModule}
            onChange={(e) => setFilterModule(e.target.value)}
            style={input}
          >
            <option value="">All Modules</option>
            {filteredModules.map((module) => (
              <option key={module.id} value={module.id}>
                {module.title}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div style={card}>
        <h3 style={{ marginBottom: "20px" }}>Lessons List</h3>

        <table style={table}>
          <thead style={tableHeader}>
            <tr>
              <th style={th}>Title</th>
              <th style={th}>Industry</th>
              <th style={th}>Course</th>
              <th style={th}>Module</th>
              <th style={th}>Video</th>
              <th style={th}>Status</th>
              <th style={th}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {currentLessons.map((lesson) => {
              const module = modules.find((m) => String(m.id) === String(lesson.module_id));
              const course = module
                ? courses.find((c) => String(c.id) === String(module.course_id))
                : null;
              const industry = course
                ? industries.find((i) => String(i.id) === String(course.industry_id))
                : null;

              return (
                <tr key={lesson.id} style={row}>
                  <td style={td}>{lesson.title}</td>
                  <td style={td}>{industry ? industry.name : ""}</td>
                  <td style={td}>{course ? course.title : ""}</td>
                  <td style={td}>{module ? module.title : ""}</td>
                  <td
                    style={{
                      ...td,
                      maxWidth: "260px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    }}
                    title={lesson.hls_video_url || lesson.home_server_url}
                  >
                    {lesson.hls_video_url || lesson.home_server_url}
                  </td>
                  <td style={td}>
                    <span
                      style={{
                        background: lesson.status === "active" ? "#27ae60" : "#e74c3c",
                        color: "#fff",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        fontSize: "13px",
                        textTransform: "capitalize"
                      }}
                    >
                      {lesson.status}
                    </span>
                  </td>
                  <td style={td}>
                    <button
                      style={editBtn}
                      onClick={() =>
                        setPage({
                          page: "edit-lesson",
                          lessonId: lesson.id
                        })
                      }
                    >
                      Edit
                    </button>

                    <button
                      style={deleteBtn}
                      onClick={() => handleDelete(lesson.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}

            {!filteredLessons.length && (
              <tr>
                <td colSpan="7" style={{ ...td, textAlign: "center", padding: "20px" }}>
                  No lessons found
                </td>
              </tr>
            )}
          </tbody>
        </table>


<div style={{ textAlign: "center", marginTop: "20px" }}>

  <button
    onClick={prevPage}
    style={paginationBtn}
    disabled={currentPage === 1}
  >
    Prev
  </button>

  <span style={{ padding: "5px 10px", fontWeight: "bold" }}>
    Page {currentPage} / {totalPages || 1}
  </span>

  <button
    onClick={nextPage}
    style={paginationBtn}
    disabled={currentPage === totalPages || totalPages === 0}
  >
    Next
  </button>

</div>

      </div>
    </div>
  );
}

/* ---------- UI STYLES ---------- */

const card = {
  background: "#fff",
  padding: "25px",
  borderRadius: "8px",
  boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
  marginBottom: "30px"
};

const input = {
  padding: "10px",
  border: "1px solid #ddd",
  borderRadius: "6px",
  fontSize: "14px",
  background: "#fff"
};

const primaryBtn = {
  background: "#2c3e50",
  color: "#fff",
  border: "none",
  padding: "10px 16px",
  borderRadius: "6px",
  cursor: "pointer"
};

const editBtn = {
  background: "#f39c12",
  border: "none",
  color: "#fff",
  padding: "6px 12px",
  marginRight: "8px",
  borderRadius: "4px",
  cursor: "pointer"
};

const deleteBtn = {
  background: "#e74c3c",
  border: "none",
  color: "#fff",
  padding: "6px 12px",
  borderRadius: "4px",
  cursor: "pointer"
};

const table = {
  width: "100%",
  borderCollapse: "collapse"
};

const tableHeader = {
  background: "#f5f6fa",
  textAlign: "left"
};

const th = {
  padding: "12px 10px",
  borderBottom: "1px solid #eee"
};

const td = {
  padding: "12px 10px",
  borderBottom: "1px solid #eee",
  verticalAlign: "middle"
};

const row = {
  borderBottom: "1px solid #eee"
};

const paginationBtn = {
  padding: "6px 14px",
  background: "#2c3e50",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer"
};

export default Lessons;
